import NewUsers from './NewUsers';

export default NewUsers;
